import { render, staticRenderFns } from "./TabsHeader.vue?vue&type=template&id=5afa503c&scoped=true&"
import script from "./TabsHeader.vue?vue&type=script&lang=js&"
export * from "./TabsHeader.vue?vue&type=script&lang=js&"
import style0 from "./TabsHeader.vue?vue&type=style&index=0&id=5afa503c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afa503c",
  null
  
)

export default component.exports